var _path, _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9999 21.6667C13.5982 21.6667 14.0833 21.1816 14.0833 20.5833V8.03206L19.8172 13.766C20.2403 14.1891 20.9262 14.1891 21.3493 13.766C21.7724 13.343 21.7724 12.657 21.3493 12.234L13.7668 4.65151C13.7642 4.64886 13.7615 4.64622 13.7588 4.64359C13.6566 4.54322 13.5395 4.4672 13.4146 4.41553C13.2869 4.36256 13.1468 4.33333 12.9999 4.33333C12.853 4.33333 12.713 4.36256 12.5852 4.41553C12.4575 4.4684 12.3378 4.54676 12.2339 4.65063L4.65055 12.234C4.22748 12.657 4.22748 13.343 4.65055 13.766C5.07362 14.1891 5.75955 14.1891 6.18262 13.766L11.9166 8.03206V20.5833C11.9166 21.1816 12.4016 21.6667 12.9999 21.6667Z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "arrowUp",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 18,
    height: 18
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9999 21.6667C13.5982 21.6667 14.0833 21.1816 14.0833 20.5833V8.03206L19.8172 13.766C20.2403 14.1891 20.9262 14.1891 21.3493 13.766C21.7724 13.343 21.7724 12.657 21.3493 12.234L13.7668 4.65151C13.7642 4.64886 13.7615 4.64622 13.7588 4.64359C13.6566 4.54322 13.5395 4.4672 13.4146 4.41553C13.2869 4.36256 13.1468 4.33333 12.9999 4.33333C12.853 4.33333 12.713 4.36256 12.5852 4.41553C12.4575 4.4684 12.3378 4.54676 12.2339 4.65063L4.65055 12.234C4.22748 12.657 4.22748 13.343 4.65055 13.766C5.07362 14.1891 5.75955 14.1891 6.18262 13.766L11.9166 8.03206V20.5833C11.9166 21.1816 12.4016 21.6667 12.9999 21.6667Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#arrowUp)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "#282F38"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/upArrow.7ed89d64e21fa41f39c0d749c2611e5a.svg";
export { ForwardRef as ReactComponent };